import React from "react";

const PlatformExperienceSection = ({ data }) => (

    <section className="sx-platform-section">

        <div className="container">

            <div className="sx-section-heading">

                <span>
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                </h2>

                {data.description && (
                    <p>
                        {data.description}
                    </p>
                )}

            </div>

            <div className="sx-platform-flow">

                {(data.items || []).map((item, index) => (

                    <div
                        className="sx-flow-item"
                        key={index}
                    >

                        <span>
                            {item.number}
                        </span>

                        <h3>
                            {item.title}
                        </h3>

                        <p>
                            {item.description}
                        </p>

                    </div>

                ))}

            </div>

        </div>

    </section>
);

export default PlatformExperienceSection;